/*==============================================================================
  COLECCIÓN · respaldo del selector de columnas
  ----------------------------------------------------------------------------
  Se carga desde sections/main-collection.liquid.

  En la tienda el tema cambia las columnas por su cuenta. Pero cuando su JS no
  arranca (pasa en el editor de temas), pulsar los iconos no hacía nada.

  Aquí se comprueba el resultado: si tras el clic la clase de columnas del grid
  no cambió, se aplica desde aquí. Si el tema respondió, no se toca nada.
==============================================================================*/
(function () {
  'use strict';

  var GRID = '.t4s_box_pr_grid';
  var CLASE_RE = /t4s-row-cols-lg-(\w+)/;

  function columnasActuales(grid) {
    var m = grid.className.match(CLASE_RE);
    return m ? m[1] : null;
  }

  function aplicar(btn, col) {
    var grid = document.querySelector(GRID);
    if (!grid) return;

    var objetivo = col === 'list_t4s' ? '1' : col;

    // Quitar cualquier clase de columnas de escritorio y poner la nueva
    grid.className = grid.className.replace(/\s*t4s-row-cols-lg-\w+/g, '');
    grid.classList.add('t4s-row-cols-lg-' + objetivo);

    // Marcar el botón activo dentro de su grupo
    var grupo = btn.closest('.t4s-layout__switch');
    if (grupo) {
      Array.prototype.forEach.call(grupo.querySelectorAll('button'), function (b) {
        b.classList.remove('is--active');
      });
      btn.classList.add('is--active');
    }
  }

  function init() {
    var grupos = document.querySelectorAll('.t4s-layout__switch');

    Array.prototype.forEach.call(grupos, function (grupo) {
      if (grupo.getAttribute('data-pux-col')) return;
      grupo.setAttribute('data-pux-col', '1');

      grupo.addEventListener('click', function (ev) {
        var btn = ev.target.closest ? ev.target.closest('button') : null;
        if (!btn || !grupo.contains(btn)) return;

        var col = btn.getAttribute('data-col');
        if (!col) return;

        var grid = document.querySelector(GRID);
        if (!grid) return;

        var objetivo = col === 'list_t4s' ? '1' : col;

        // Se espera un instante: si el tema ya lo cambió, no se hace nada
        setTimeout(function () {
          if (columnasActuales(grid) !== objetivo) aplicar(btn, col);
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor vuelve a pintar la sección sin recargar
  document.addEventListener('shopify:section:load', init);
})();
